/**
 * fiko-komut.tanim.ts — Veri-odaklı komut + parametre tanımları (CATIA tarzı komut penceresi).
 * Her komut bir IKomutTanim; pencere bunu okuyup parametre alanlarını üretir,
 * değişimde FikoModellemeYonetici.komutGuncelle → canlı önizleme (rebuild).
 */

export type KomutParamTip = 'sayi' | 'tamsayi' | 'mesafe' | 'aci' | 'boolean' | 'secim' | 'metin' | 'duzlemRef' | 'eksenRef' | 'ref';

export interface IKomutParam {
  anahtar: string;        // IOzellik alanı: param/adet/aralik/aci/adet2/aralik2/aynaTip/ekleme
  etiket: string;         // Türkçe etiket
  tip: KomutParamTip;
  varsayilan: number | boolean | string;
  birim?: string;         // 'mm' | '°'
  min?: number;
  max?: number;
  adim?: number;
  secenekler?: { deger: any; etiket: string }[];   // tip==='secim'
  refTipler?: string[];                            // tip==='ref' — seçilebilir tür(ler): nokta3d/cizgi3d/yuz/kenar/vertex…
  gorunur?: (d: Record<string, any>) => boolean;   // koşullu görünürlük (CATIA: moda göre alan göster/gizle)
}

export interface IKomutTanim {
  id: string;             // 'pad' | 'pocket' | 'patternDik' ...
  etiket: string;
  ikon: string;           // semantic-ui ikon adı
  workbench: string;      // 'part' | 'sketcher' ...
  gerektirir?: 'sketch' | 'govde';   // ön koşul
  parametreler: IKomutParam[];
}

/** Tanımın varsayılan parametre değer haritası. */
export function komutVarsayilan(t: IKomutTanim): Record<string, any> {
  const o: Record<string, any> = {};
  for (const p of t.parametreler) o[p.anahtar] = p.varsayilan;
  return o;
}
